define('notify-service',['_'], function() {

  var app = angular.module('notify.service', []);

  var notifyService = ['$rootScope', function ($rootScope) {

    $rootScope.notifications = [];

    return {

      addNotification: function(type, message) {

        if (_.isArray(arguments[0])) {
          $rootScope.notifications = $rootScope.notifications.concat(arguments[0]);
        } else if (_.isPlainObject(arguments[0])) {
          $rootScope.notifications.push(arguments[0]);
        } else {
          $rootScope.notifications.push({
            type: type,
            message: message
          });
        }

      },

      clearNotifications: function() {
        $rootScope.notifications = [];
      }

    }
  }];

  app.service('notify', notifyService);
  app.service('$notify', notifyService);

});

